module.exports = __webpack_public_path__ + "static/media/education-object-4-1-1.d1281091.svg";